module.exports = __webpack_public_path__ + "img/7.9f770e68.jpg";